import React, { useState, useEffect } from 'react'
import { useParams, useNavigate } from 'react-router-dom'
import { useAuth } from 'contexts/AuthContext'
import CommunityService from 'service/CommunityService'
import ChatRoomModal from '../components/ChatRoomModal/ChatRoomModal'

export default function ChatRoomPage() {
  const { roomSlug } = useParams()
  const navigate = useNavigate()
  const { user } = useAuth()
  const [room, setRoom] = useState(null)
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)

  useEffect(() => {
    loadRoom()
  }, [roomSlug])

  const loadRoom = async () => {
    try {
      setLoading(true)
      const response = await CommunityService.getChatRoom(roomSlug)
      setRoom(response.data)
    } catch (err) {
      setError('Комната не найдена')
    } finally {
      setLoading(false)
    }
  }

  const handleClose = () => navigate(-1)

  if (loading) {
    return (
      <div style={{ width: '100vw', height: '100vh', background: '#1a1a1a', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#fff', fontSize: 18 }}>
        Загрузка...
      </div>
    )
  }

  if (error || !room) {
    return (
      <div style={{ width: '100vw', height: '100vh', background: '#1a1a1a', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#fff', fontSize: 18 }}>
        {error || 'Ошибка загрузки'}
      </div>
    )
  }

  return (
    <ChatRoomModal
      room={room}
      currentUser={user}
      onClose={handleClose}
      isOwner={room.owner?.id === user?.id}
    />
  )
}
